// extracted by mini-css-extract-plugin
export default {"container":"RvH2VW","text":"XuOzcf","spinner":"yysZwE"};